import "../styles.css";
import { SocialMediaIconsReact } from "social-media-icons-react";
import React from "react";
//0509034660
const socialIcons = () => {
  return (
    <div>
      <h3 className="contact-us">Contact Us</h3>
      <div className="top-body-socials">
        <SocialMediaIconsReact
          borderColor="rgba(0,0,0,0.25)"
          borderWidth="5"
          borderStyle="none"
          icon="phone"
          iconColor="rgba(255,255,255,1)"
          backgroundColor="rgba(26,166,233,1)"
          iconSize="2"
          roundness="20%"
          url="tel:0509034660"
          size="30"
        />
        <SocialMediaIconsReact
          borderColor="rgba(0,0,0,0.25)"
          borderWidth="5"
          borderStyle="none"
          icon="whatsapp"
          iconColor="rgba(255,255,255,1)"
          iconSize="2"
          roundness="20%"
          url="https://wa.me/+233509034660"
          size="30"
        />

        <SocialMediaIconsReact
          borderColor="rgba(0,0,0,0.25)"
          borderWidth="5"
          borderStyle="none"
          icon="instagram"
          iconColor="rgba(255,255,255,1)"
          backgroundColor="rgba(234,8,115,1)"
          iconSize="2"
          roundness="20%"
          url="https://www.instagram.com/p/BzgUHMmlIoX/?igshid=MDJmNzVkMjY="
          size="30"
        />
      </div>
    </div>
  );
};

export default socialIcons;
